export default "__VITE_ASSET__Cqq$Xm_K__"